const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
    <div className="px-6 py-4">
      <p className="text-gray-600 text-sm text-center">
        © {new Date().getFullYear()} Lernvent Event Management. All rights reserved.
      </p>
    </div>
  </footer>
  );
};  

export default Footer